/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Updated_LabelInputs */

const en_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Updated:`)
};

const fr_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derniere mise a jour :`)
};

const de_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Aktualisierung:`)
};

const it_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento:`)
};

const ru_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее обновление:`)
};

const es_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización:`)
};

const zh_cn2_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后更新时间：`)
};

const ja_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新日:`)
};

const hi_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आखरी अपडेट:`)
};

const pt_pt2_preset_manager_updated_label = /** @type {(inputs: Preset_Manager_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização:`)
};

/**
* | output |
* | --- |
* | "Last Updated:" |
*
* @param {Preset_Manager_Updated_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_updated_label = /** @type {((inputs?: Preset_Manager_Updated_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Updated_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_updated_label(inputs)
	if (locale === "de") return de_preset_manager_updated_label(inputs)
	if (locale === "it") return it_preset_manager_updated_label(inputs)
	if (locale === "ru") return ru_preset_manager_updated_label(inputs)
	if (locale === "es") return es_preset_manager_updated_label(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_updated_label(inputs)
	if (locale === "ja") return ja_preset_manager_updated_label(inputs)
	if (locale === "hi") return hi_preset_manager_updated_label(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_updated_label(inputs)
	return en_preset_manager_updated_label(inputs)
});